import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import Nav from "./components/Nav";
import PageHeader from "./components/PageHeader";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import ChatPage from "./pages/ChatPage";
import MembershipPage from "./pages/MembershipPage";
import PortalPage from "./pages/PortalPage";
import ItineraryDetail from "./pages/ItineraryDetail";
import HostPortal from "./pages/HostPortal";
import HostsPage from "./pages/HostsPage";
import HostProfile from "./pages/HostProfile";
import HostTiersPage from "./pages/HostTiersPage";
import PropertyAssistancePage from "./pages/PropertyAssistancePage";
import RentalToRentPage from "./pages/RentalToRentPage";
import StaysPage from "./pages/StaysPage";
import AddOnsPage from "./pages/AddOnsPage";
import { Navigate } from "react-router-dom";
import AdminDashboard from "./pages/AdminDashboard";
import AdminListingsPage from "./pages/AdminListingsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import MarketingConsentModal from "./components/MarketingConsentModal";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ConciergePage from "./pages/ConciergePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import JoinPage from "./pages/JoinPage";
import TenantThrivePage from "./pages/TenantThrivePage";
import GuestSignInPage from "./pages/GuestSignInPage";
import HostSignInPage from "./pages/HostSignInPage";
// JT.Jewels catalog routes consolidated into /jt-essentials (AddOnsPage)
// — old imports removed to keep the bundle slim.
import CreateGroupPage from "./pages/CreateGroupPage";
import GroupDetailPage from "./pages/GroupDetailPage";
import GroupInvitePage from "./pages/GroupInvitePage";
import AcceptanceSuccessPage from "./pages/AcceptanceSuccessPage";
import AcceptanceCancelledPage from "./pages/AcceptanceCancelledPage";
import ClientIdNoticeModal from "./components/ClientIdNoticeModal";
import InstallPwaPrompt from "./components/InstallPwaPrompt";
import LegalPage from "./pages/LegalPage";
import DuffelDemoPage from "./pages/DuffelDemoPage";
import QrPage from "./pages/QrPage";
import ScrollToTop from "./components/ScrollToTop";
import BackToSashaButton from "./components/BackToSashaButton";
import FloatingSashaBubble from "./components/FloatingSashaBubble";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <PageHeader />
          <Routes>
            <Route path="/" element={<ChatPage />} />
            <Route path="/qr" element={<QrPage />} />
            <Route path="/talk-to-sasha" element={<ChatPage />} />
            <Route path="/Talk-To-Sasha" element={<ChatPage />} />
            <Route path="/Talk-to-Sasha" element={<ChatPage />} />
            <Route path="/sasha" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/chat" element={<Navigate to="/talk-to-sasha" replace />} />
            {/* Corina was retired — all chat is Sasha. Old Corina links 301 to Sasha. */}
            <Route path="/talk-to-corina" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/Talk-To-Corina" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/Talk-to-Corina" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/corina" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/hosts/concierge" element={<Navigate to="/talk-to-sasha" replace />} />
            <Route path="/home" element={<Landing />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/tenant-thrive" element={<TenantThrivePage />} />
            <Route path="/subscriptions" element={<MembershipPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/portal" element={<PortalPage />} />
            <Route path="/itinerary/:id" element={<ItineraryDetail />} />
            <Route path="/host" element={<HostPortal />} />
            <Route path="/hosts" element={<HostsPage />} />
            <Route path="/hosts/tiers" element={<HostTiersPage />} />
            <Route path="/hosts/property-assistance" element={<PropertyAssistancePage />} />
            <Route path="/hosts/rental-to-rent" element={<RentalToRentPage />} />
            <Route path="/hosts/:hostId" element={<HostProfile />} />
            <Route path="/stays" element={<StaysPage />} />
            <Route path="/jewel-store" element={<Navigate to="/jt-essentials" replace />} />
            <Route path="/jewel-store/:slug" element={<Navigate to="/jt-essentials" replace />} />
            <Route path="/add-ons" element={<Navigate to="/jt-essentials" replace />} />
            <Route path="/jt-essentials" element={<AddOnsPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/listings" element={<AdminListingsPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/guest-signin" element={<GuestSignInPage />} />
            <Route path="/host-signin" element={<HostSignInPage />} />
            <Route path="/concierge" element={<ConciergePage />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/groups/new" element={<CreateGroupPage />} />
            <Route path="/groups/invite/:token" element={<GroupInvitePage />} />
            <Route path="/groups/:id" element={<GroupDetailPage />} />
            <Route path="/acceptance/success" element={<AcceptanceSuccessPage />} />
            <Route path="/acceptance/cancelled" element={<AcceptanceCancelledPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/duffel-demo" element={<DuffelDemoPage />} />
            <Route path="/terms" element={<Navigate to="/legal#bookings" replace />} />
            <Route path="/privacy" element={<Navigate to="/legal#privacy" replace />} />
            <Route path="/sms" element={<Navigate to="/legal#sms" replace />} />
          </Routes>
          <ClientIdNoticeModal />
          <InstallPwaPrompt />
          <BackToSashaButton />
          {/* Site-wide floating Sasha info-desk bubble. Hides itself on
              /talk-to-sasha and admin/portal/concierge routes so we never
              show two Sashas on the same surface. */}
          <FloatingSashaBubble />
          <WhatsAppButton />
          <Footer />
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#FDFBF7",
                color: "#0A3622",
                border: "1px solid rgba(193,157,96,0.3)",
                fontFamily: "Outfit, sans-serif",
                letterSpacing: "0.02em",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
